//REGISTER
export const POST_FAKE_REGISTER = "/post-fake-register";

//LOGIN
export const POST_FAKE_LOGIN = "/post-fake-login";
export const POST_FAKE_JWT_LOGIN = "/post-jwt-login";
export const POST_FAKE_PASSWORD_FORGET = "/fake-forget-pwd";
export const POST_FAKE_JWT_PASSWORD_FORGET = "/jwt-forget-pwd";
export const SOCIAL_LOGIN = "/social-login";

//PROFILE
export const POST_EDIT_JWT_PROFILE = "/post-jwt-profile";
export const POST_EDIT_PROFILE = "/post-fake-profile";

//CALENDER
export const GET_EVENTS = "/events";
export const ADD_NEW_EVENT = "/add/event";
export const UPDATE_EVENT = "/update/event";
export const DELETE_EVENT = "/delete/event";
export const GET_CATEGORIES = "/categories";

//CHATS
export const GET_CHATS = "/chats";
export const GET_GROUPS = "/groups";
export const GET_CONTACTS = "/contacts";
export const GET_MESSAGES = "/messages";
export const ADD_MESSAGE = "/add/messages";

// —— DC Keeper 資源端點（REST，mock 與真後端共用同一組路徑）——
// —— DC Keeper 真後端（Web API Backend v1.00；路徑前綴 /api-backend/{Controller}/{Action}）——
// 逐資源切換用(ADR-0001):mock REST(下方 DCK)隨對應真 API 到位逐步汰換。
export const DCK_BACKEND = {
  // Authenticate：管理員登入取得 JWT（全 API 唯一免 token 端點）
  AUTH_GET_TOKEN: "/api-backend/Authenticate/GetToken",
  // 人員管理－權限設定（DCK-01-01）
  CUSTOMER_ROLE: "/api-backend/DcCustomerRole",
  // 人員管理－使用者資訊（DCK-01-02）
  CUSTOMER: "/api-backend/DcCustomer",
  // 機房管理－位置設定（DCK-03-01;2026-08-11 後端新增,DTO 明細待 smoke 探索/文件展開)
  // 動作:Room CRUD+CanDelete、Floor(GetFloors/CreateFloor/UpdateFloor/DeleteFloor)、
  // Area(GetAreas/GetAreasByRoom/CreateArea/UpdateArea/DeleteArea)
  ROOM: "/api-backend/DcRoom",
  // 資產管理－機櫃（DCK-05-01;票 20。動作:CRUD + CanDelete）
  RACK: "/api-backend/DcRack",
  // 批次匯入－DC Keeper 標準範本 xlsx（multipart `file`,回 ImportResultDto）。
  // 只走 ImportDcKeeperHardware／ImportDcKeeperSoftware。
  IMPORT: "/api-backend/DcImport",
  // 資產管理－硬體（DCK-05-02;票 21。動作:CRUD,**沒有 CanDelete** ——
  // 與機櫃/機房不同,硬體的刪除前檢查後端沒給,阻擋只能靠 Delete 的錯誤回應）
  HARDWARE: "/api-backend/DcHardware",
  // 資產管理－廠牌／型號主檔（2026-08-17 規格書新增;票 32)。**全部唯讀**,
  // 沒有 Create/Update/Delete —— 主檔由後端維護,前端只查。
  // 硬體/軟體/機櫃的 brand_id / model_id 都指向這裡,是那三票的前置件。
  BRAND: "/api-backend/DcBrand",
  // 資產管理－軟體（DCK-05-03;票 35。動作:CRUD + CanDelete + 部署設備三支）
  // AddDeployment／RemoveDeployment 契約是 **GET 但會改資料**（Q1 未決）——
  // helper 帶 cache-buster；前端業務路徑**不要**在 smoke 裡打這兩支。
  SOFTWARE: "/api-backend/DcSoftware",
  // 資產版本／弱點爬蟲（票 29）。**前端只讀不寫** ——
  // 這支 controller 另有 UpdateVersion／ReportFailure 兩支 POST(建 run、發失效告警),
  // 那是爬蟲自己的寫回入口,前端不碰(8/12 探測誤打過一次的教訓,見票 14)。
  ASSET_VERSION: "/api-backend/AssetVersion",
  // 智慧看板（DCK-02;2026-08-22 swagger 七支 GET）。**全部唯讀**。
  DASHBOARD: "/api-backend/Dashboard",
  // 系統－後台左選單（依角色權限動態篩選）
  ADMIN_MENU: "/api-backend/AdminMenu",
  // 系統－通用資料
  COMMON: "/api-backend/Common",
};

export const DCK = {
  // 01 人員管理
  ROLES: "/api/roles",
  USERS: "/api/users",
  WORK_ITEMS: "/api/work-items",
  // 03 機房管理
  ROOMS: "/api/rooms",
  // 04 IP/專案/合約/廠商
  IPS: "/api/ips",
  PROJECTS: "/api/projects",
  CONTRACTS: "/api/contracts",
  VENDORS: "/api/vendors",
  // 05 資產管理
  CABINETS: "/api/cabinets",
  HARDWARE: "/api/hardware",
  SOFTWARE: "/api/software",
  // 06 監控(正式版介接 WhatsUp Gold;mock 先以資源端點模擬)
  MONITOR_DEVICES: "/api/monitor/devices",
  // 07 訊息功能
  NOTIFICATIONS: "/api/notifications",
  NOTIFY_MUTE_RULES: "/api/notify-mute-rules",
  // 共用：三關審核
  APPROVALS: "/api/approvals",
  AUDIT_ARCHIVE: "/api/audit-archive",
  // 認證相關（密碼重設）
  AUTH: "/api/auth",
};
